import { useState } from 'react';
import { getCurrencySymbol } from '../utils/currency';
import { fetchTickerData } from '../services/api';

export const useTicker = () => {
  const [ticker, setTicker] = useState('');
  const [loading, setLoading] = useState(false);
  const [tickerError, setTickerError] = useState('');
  const [tickerResult, setTickerResult] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!ticker.trim()) {
      setTickerError("Please enter a ticker symbol.");
      return;
    }

    setLoading(true);
    setTickerError(null);
    setTickerResult(null);

    const result = await fetchTickerData(ticker.trim());

    if (result.success) {
      // Get currency information based on ticker
      const currencyInfo = getCurrencySymbol(result.data.ticker);
      
      setTickerResult({
        ...result.data,
        currencySymbol: currencyInfo.symbol,
        currencyName: currencyInfo.name,
      });
      setTickerError(null);
    } else {
      setTickerError(result.error);
      setTickerResult(null);
    }

    setLoading(false);
  };

  return {
    ticker,
    setTicker,
    loading,
    tickerError,
    tickerResult,
    handleSubmit,
  };
};
